import { IPatientWaitingListState } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";
import { useAtHomeBookingStatusSummaryAPI } from "../PWL/useAtHomeBookingStatusSummaryAPI";

const useRefetchAtHomeStats = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("PATIENT_WAITING_LIST", "id"));
  const { atHomeStatsFilters } = routeState.state as IPatientWaitingListState;
  const fetchAtHomeStats = useAtHomeBookingStatusSummaryAPI();

  const execute = async () => {
    if (!atHomeStatsFilters || Object.keys(atHomeStatsFilters)?.length === 0) return;
    await fetchAtHomeStats(atHomeStatsFilters);
  };

  return execute;
};

export default useRefetchAtHomeStats;
